export function writeToSessionStorage(key: string, value: any): void {
    window.sessionStorage.setItem(key, JSON.stringify(value));
}

export function readFromSessionStorage(key: string): any | null {
    const rawValue = window.sessionStorage.getItem(key);
    return rawValue ? JSON.parse(rawValue) : null;
}

export function clearSessionStorage(): void {
    window.sessionStorage.clear();
}
